var map = {
	"./ikonaBrudnopis-OFF.png": "005e",
	"./ikonaBrudnopis-ON.png": "c638",
	"./ikonaCwiczenie-OFF.png": "0d7c",
	"./ikonaCwiczenie-ON.png": "5aa2",
	"./ikonaCwiczenieDisabled-OFF.png": "e973",
	"./ikonaCwiczenieDisabled-ON.png": "4bbb",
	"./ikonaFilm-OFF.png": "27c6",
	"./ikonaFilm-ON.png": "ffd2",
	"./ikonaFilmDisabled-OFF.png": "143a",
	"./ikonaFilmDisabled-ON.png": "4538",
	"./ikonaGaleria-OFF.png": "53a1",
	"./ikonaGaleria-ON.png": "e2f6",
	"./ikonaGaleriaDisabled-OFF.png": "da3a",
	"./ikonaGaleriaDisabled-ON.png": "8695",
	"./ikonaGimp-OFF.png": "5616",
	"./ikonaGimp-ON.png": "de49",
	"./ikonaGimpDisabled-OFF.png": "5d6e",
	"./ikonaGimpDisabled-ON.png": "517c",
	"./ikonaIrfan-OFF.png": "4d7d",
	"./ikonaIrfan-ON.png": "7b83",
	"./ikonaIrfanDisabled-OFF.png": "26c6",
	"./ikonaIrfanDisabled-ON.png": "75ccf",
	"./ikonaMikrofon-OFF.png": "789a",
	"./ikonaMikrofon-ON.png": "0363",
	"./ikonaMikrofonDisabled-OFF.png": "4ef8",
	"./ikonaMikrofonDisabled-ON.png": "9e3a",
	"./ikonaMuzyka-OFF.png": "bbc2",
	"./ikonaMuzyka-ON.png": "b68e",
	"./ikonaMuzykaDisabled-OFF.png": "cce6",
	"./ikonaMuzykaDisabled-ON.png": "7239",
	"./ikonaNotatka-OFF.png": "c51f",
	"./ikonaNotatka-ON.png": "6770",
	"./ikonaNotatkaDisabled-OFF.png": "543b",
	"./ikonaNotatkaDisabled-ON.png": "9771",
	"./ikonaNotatnik-OFF.png": "d916",
	"./ikonaNotatnik-ON.png": "44a0",
	"./ikonaNotatnikDisabled-OFF.png": "6b71",
	"./ikonaNotatnikDisabled-ON.png": "d438",
	"./ikonaPaint-OFF.png": "c5c4",
	"./ikonaPaint-ON.png": "f3af",
	"./ikonaPaintDisabled-OFF.png": "43bd",
	"./ikonaPaintDisabled-ON.png": "6ebd",
	"./ikonaPobierz-OFF.png": "17c7",
	"./ikonaPobierz-ON.png": "ab27",
	"./ikonaPrezentacja-OFF.png": "373d",
	"./ikonaPrezentacja-ON.png": "8ffeb",
	"./ikonaPrezentacjaDisabled-OFF.png": "8566",
	"./ikonaPrezentacjaDisabled-ON.png": "62d9",
	"./ikonaPython-OFF.png": "59ae",
	"./ikonaPython-ON.png": "9a35",
	"./ikonaScenariusz-OFF.png": "f733",
	"./ikonaScenariusz-ON.png": "8be1",
	"./ikonaScratch-OFF.png": "4ec3",
	"./ikonaScratch-ON.png": "da78",
	"./ikonaSluchowisko-OFF.png": "ee9c",
	"./ikonaSluchowisko-ON.png": "eea5",
	"./ikonaStepbystep-OFF.png": "72b4",
	"./ikonaStepbystep-ON.png": "1d98",
	"./ikonaTabela-OFF.png": "d2ff",
	"./ikonaTabela-ON.png": "4f77",
	"./ikonaTablice-OFF.png": "4c6c",
	"./ikonaTablice-ON.png": "e2d0",
	"./ikonaTekst-OFF.png": "ef91",
	"./ikonaTekst-ON.png": "7e2d",
	"./ikonaWWW-OFF.png": "34fe",
	"./ikonaWWW-ON.png": "3549",
	"./ikonaZdjecie-OFF.png": "977c",
	"./ikonaZdjecie-ON.png": "78e0",
	"./ikona_cw1-OFF.png": "f75d",
	"./ikona_cw1-ON.png": "c78b",
	"./ikona_cw2-OFF.png": "a86af",
	"./ikona_cw2-ON.png": "4bdf",
	"./ikona_cw3-OFF.png": "4bd0",
	"./ikona_cw3-ON.png": "4201",
	"./ikona_cw4-OFF.png": "6561",
	"./ikona_cw4-ON.png": "cae3",
	"./ikona_cw5-OFF.png": "c154",
	"./ikona_cw5-ON.png": "9e7d",
	"./ikona_cw6-OFF.png": "02f4",
	"./ikona_cw6-ON.png": "ed36",
	"./ikona_cw7-OFF.png": "b87b",
	"./ikona_cw7-ON.png": "f52a",
	"./ikona_film-OFF.png": "384f",
	"./ikona_film-ON.png": "b2d8",
	"./ikona_galeria-OFF.png": "f825",
	"./ikona_galeria-ON.png": "df53"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0138";